import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin.commons')
  .filter('customerDefaultAddress', customerDefaultAddress);

/* @ngInject */
function customerDefaultAddress($translate, splitService, $filter) {
  return function(customer) {
    var defaultAddress = _.find(customer.addresses, (a) => {
      return a.id === customer.defaultAddressId
    });
    return $filter('bringozAddress')(defaultAddress, true);
  };
}
